class IndexProductGallery extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.setSwiper();
  }
  setSwiper() {
    const mySwiper = new Swiper('.index-product-gallery-swiper', {
      loop: true,
      slidesPerView: 1.1,
      centeredSlides: true,
      spaceBetween: 20,
      lazy: false,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
    })
  }
}

customElements.define('index-product-gallery', IndexProductGallery);


class IndexProductGalleryColorOptions extends HTMLElement {
  constructor() {
    super();
    this.tempEle = this.querySelector('.p-color-options-template');
  }
  connectedCallback() {
    this.setColor();
  }
  getColorData() {
    if (this.tempEle.innerHTML && this.tempEle.innerHTML.trim() !== '') {
      return JSON.parse(this.tempEle.innerHTML.trim());
    } else {
      return [];
    }
  }
  setColor() {
    if (this.getColorData().length === 0) return;
    this.getColorData().forEach(item => {
      const colorLabel = this.querySelector(`.index-product-gallery-color-options .p-color-option-label[data-color="${item.source}"]`);
      if (colorLabel) {
        if (item.type === 'color') {
          colorLabel.style.setProperty('--value', item.destination);
        } else if (item.type === 'image') {
          colorLabel.style.setProperty('--value', `url(${item.destination})`);
        }
      }
    })
  }
}

customElements.define('index-product-gallery-color-options', IndexProductGalleryColorOptions);

